import gql from "graphql-tag";

export default gql`
  query getLastOrder($userId: ID) {
    getLastOrder(userId: $userId) {
      id
      userId
      serviceId
      serviceTitle
      createdAt
      status
      paid
      amount
      discount
      partnerAssignedId
      service {
        shortDescription
        description
        deliveryHours
        tags
        specs
        category {
          slug
          description
          title
          picture {
            bucket
            region
            key
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Query/GetLastOrder.js